<template>
    <div class="price-tag">
        <div class="price-tag__wrapper">
            <div class="price-tag__header">{{curTagData.skuName}}</div>
            <div class="price-tag__barCode">
                <canvas :id="curBarCodeId" class="price-tag__barCode_element"></canvas>
            </div>
            <div class="price-tag__info">
                <div
                    class="price-tag__info_item"
                >{{`储存条件:${curTagData.storageTemperatureLevelName}`}}</div>
                <div class="price-tag__info_item">{{`规格:${curTagData.actualSpec}`}}</div>
            </div>
            <div class="price-tag__info">
                <div
                    class="price-tag__info_item"
                >{{`${(curTagData.dateInfo||{}).labelDesc||''}${(curTagData.dateInfo||{}).labelValue||''}`}}</div>
                <div class="price-tag__info_item">{{`产地:${curTagData.produceAreaName}`}}</div>
            </div>
            <div class="price-tag__info">
                <div style="height:1px;background:black;"></div>
            </div>
            <div class="price-tag__info_supplierInfo" v-if="curTagData.supplierCertName">
               供应商:{{curTagData.supplierCertName}}
            </div>
            <div class="price-tag__info price-tag__info_footer" style="margin-bottom:0px;">
                <div
                    class="price-tag__info_item"
                >{{`${(curTagData.customInfo||{}).labelDesc||''}${(curTagData.customInfo||{}).labelValue||''}`}}</div>
                <div class="price-tag__info_item price-tag__info_extra_code">
                    <span v-if="curTagData.extraCode">{{curTagData.extraCode}}</span>
                    <slot v-else name="extraCode"></slot>
                </div>
            </div>
            <div class="price-tag__info price-tag__info_footer" style="margin-top:0px;">
                <span class="price-tag__time">{{serviceTime}}</span>
                <img :src="iconMaps.mc" alt="logo" class="price-tag__logo" />
            </div>
        </div>
    </div>
</template>

<script>
import { iconMaps } from '../logos/constant';

export default {
    name: 'XxPieceCode',
    props: {
        // 渲染价签需要的数据
        tagData: {
            type: Object,
            default: () => ({}),
            required: true
        },
        // 字段转换map,在服务端提供的字段跟预置模板不一致的时候进行字段转换
        formatMap: {
            type: Object,
        },
        // 给要挂载码的节点指定id
        formatBarCodeId: {
            type: Function,
        },
        serviceTime: {
            type: String,
            default: '服务时间:07:00~23:30'
        }
    },
    data() {
        return {
            iconMaps
        };
    },
    computed: {
        curTagData() {
            const { formatMap, tagData } = this;
            if (!formatMap) {
                return tagData;
            }
            return this.transalte(formatMap, tagData);
        },
        curBarCodeId() {
            const { formatBarCodeId, tagData } = this;
            if (formatBarCodeId) {
                return `_${formatBarCodeId(tagData)}`;
            }
            return `_${tagData.barCode}`;
        }
    },
    methods: {
        // 值key转换
        transalte(formatMap, tagData) {
            return Object.entries(tagData || {}).reduce((prev, next) => {
                const [key, value] = next;
                formatMap[key] ? prev[formatMap[key]] = value : prev[key] = value;
                return prev;
            }, {});
        }
    },

};

</script>

<style lang="scss" scoped>
* {
    box-sizing: content-box;
}
.price-tag {
    .price-tag__wrapper {
        width: 300px;
        padding: 0 20px;
        font-family: ESim font;
        .price-tag__header {
            font-size: 15px;
            text-align: center;
            font-weight: normal;
        }
        .price-tag__barCode {
            margin: 4px 0;
            text-align: center;
        }
        .price-tag__barCode_element {
            width: 90%;
        }
        .price-tag__info {
            margin: 4px 0;
            position: relative;
            overflow: hidden;
        }
        .price-tag__info_item {
            float: left;
            width: 50%;
            font-size: 14px;
        }
        .price-tag__divide {
            height: 1px;
            margin: 5px 0;
            background-color: black;
        }
        .price-tag__logo {
            width: 100px;
            float: right;
        }
        .price-tag__info_extra_code {
            text-align: right;
        }
        .price-tag__info_footer .price-tag__info_item {
            font-size: 12px;
        }
        .price-tag__time {
            font-size: 12px;
            line-height: 3;
            float: left;
        }
        .price-tag__logo_wrapper {
            vertical-align: bottom;
        }
        .price-tag__info_supplierInfo{
            font-size: 12px;
        }
    }
}
</style>
